function unaVez(elemento, evento, accion) {
    const funcion = (e) => {
        if (accion(e) !== false) {
            elemento.removeEventListener(evento, funcion);
        }
    };
    elemento.addEventListener(evento, funcion);
}
export { unaVez };
